module.exports = __webpack_public_path__ + "static/media/screen-pwa-portfolio.a33f05e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/WorksSection/screens/screen-pwa-portfolio.png
// module id = 328
// module chunks = 0